export default "__VITE_ASSET__5e63f5b0__"